import { SvgProps } from './ic_portfolio';

export function IconFuture(props: SvgProps) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={25}
            height={24}
            fill="none"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="m17.466 13.355-1.741 1.682a.764.764 0 0 1-.532.212.764.764 0 0 1-.532-.212l-.002-.002-1.739-1.68a.7.7 0 0 1 .003-1.018.771.771 0 0 1 1.06.002l.459.444V8.012c0-.398.336-.72.75-.72s.75.322.75.72v4.773l.461-.446a.771.771 0 0 1 1.06-.002.7.7 0 0 1 .003 1.018Zm-5.387-3.332a.771.771 0 0 1-1.061-.003l-.461-.444v4.775c0 .397-.336.72-.75.72s-.75-.323-.75-.72V9.577l-.459.443a.771.771 0 0 1-1.061.003.699.699 0 0 1-.003-1.018l1.743-1.682a.762.762 0 0 1 .531-.212c.2 0 .391.076.532.212l1.742 1.682a.699.699 0 0 1-.003 1.018Zm4.395-7.963H8.526C5.221 2.06 3 4.098 3 7.13v8.096C3 18.261 5.221 20.3 8.526 20.3h7.948c3.305 0 5.526-2.038 5.526-5.073V7.131c0-3.033-2.221-5.071-5.526-5.071Z"
                clipRule="evenodd"
            />
        </svg>
    );
}
